// @flow
import styled from 'styled-components';

export const RgbFlipper = styled.div`
    height: 100%;
    position: relative;
    width: 100%;
`;

export const FlipperContainer = styled.div`
    position: absolute;
    top: 15.5%;
    left: 15.5%;
    z-index: 2;
    width: 69%;
    height: 69%;
    border-radius: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/rgb-flipper/styles.js